"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAiConfigHashPayload = buildAiConfigHashPayload;
exports.canonicalJson = canonicalJson;
exports.computeAiConfigContentHash = computeAiConfigContentHash;
const crypto_1 = require("crypto");
function buildAiConfigHashPayload(aiConfig) {
    return {
        type: aiConfig.type || '',
        provider: aiConfig.provider || '',
        model: aiConfig.model || '',
        prompt: aiConfig.prompt && typeof aiConfig.prompt === 'object' ? aiConfig.prompt : {},
        options: aiConfig.options || '',
    };
}
function canonicalJson(value) {
    return JSON.stringify(canonicalize(value));
}
function computeAiConfigContentHash(aiConfig) {
    return (0, crypto_1.createHash)('sha256').update(canonicalJson(buildAiConfigHashPayload(aiConfig))).digest('hex');
}
function canonicalize(value) {
    if (Array.isArray(value)) {
        return value.map(canonicalize);
    }
    if (!value || typeof value !== 'object') {
        return value;
    }
    const record = value;
    return Object.keys(record)
        .filter((key) => record[key] !== undefined)
        .sort()
        .reduce((accumulator, key) => {
        accumulator[key] = canonicalize(record[key]);
        return accumulator;
    }, {});
}
